import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DelayIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Delay",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.69 10.61V5.23h.53c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62H5.77c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h.53v5.38c0 .56.29 1.05.72 1.34S13.08 16 13.08 16l-6.06 4.04c-.44.29-.72.79-.72 1.34v5.39h-.53c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h20.46c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62h-.53v-5.39c0-.56-.29-1.05-.72-1.34s-6.06-4.05-6.06-4.05l6.06-4.04c.43-.3.71-.79.71-1.34m-3.22 11.64v4.52h-2.15v-1.92c0-.75-.39-1.41-.97-1.8s-2.22-1.35-2.22-1.35c-.32-.21-.72-.33-1.14-.33s-.82.12-1.15.33-2.15 1.34-2.15 1.34a2.16 2.16 0 0 0-1.01 1.82v1.89H9.56v-4.51l6.46-4.31 6.46 4.31Zm0-12.5-6.46 4.3-6.46-4.3V5.23h12.93v4.52Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.57 31.86c-7.56 0-13.71-6.15-13.71-13.71S8.01 4.43 15.57 4.43s13.71 6.15 13.71 13.71-6.15 13.71-13.71 13.71Zm0-25.15c-6.3 0-11.43 5.13-11.43 11.43s5.13 11.43 11.43 11.43S27 24.44 27 18.14 21.87 6.71 15.57 6.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.42 24.13c-.29 0-.58-.11-.81-.33l-4.85-4.85a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l4.85 4.85a1.14 1.14 0 0 1-.81 1.95M19 2.14h-6.86a1.14 1.14 0 1 1 0-2.28H19a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 6.71c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M21.85 8.4c-.19 0-.39-.05-.57-.15-.55-.32-.73-1.01-.42-1.56l1.71-2.97c.32-.55 1.02-.73 1.56-.42.55.32.73 1.01.42 1.56l-1.71 2.97c-.21.37-.6.57-.99.57"
      })]
    })
  }));
};